<template>
  <div class="left-options">
    <bread-tag></bread-tag>
  </div>
  <div class="right-options">
    <a-badge
      :count="store?.state?.notice?.noticeCount"
      :overflowCount="999999999"
      :offset="[5, 0]"
      class="inline-block mr-20px cursor-pointer"
      @click="state.showNoticeInfoList = true"
    >
      <img
        class="mr-5px h-20px inline-block align-middle"
        src="@/assets/img/notification.svg"
        alt=""
      />
      <span class="inline-block align-middle">
        {{
          state.lang === 'zh-CN'
            ? '信息知识中心'
            : 'Information and Knowledge Center'
        }}
      </span>
    </a-badge>

    <SearchOutlined
      class="mr20 pointer"
      style="font-size:18px;"
      @click="openSearchPanel"
    />
    <FullscreenOutlined
      v-if="!parentState.isFullScreen"
      class="mr10 fs18"
      @click="parentState.fullScreen"
    />
    <FullscreenExitOutlined
      class="mr10 fs18"
      style="color:#1890ff"
      v-else
      @click="parentState.fullScreen"
    />

    <!-- 下载 -->
    <download />
    <!-- 中英文 -->
    <a-select
      v-model:value="state.lang"
      @change="onChange"
      class=" mr10 lang"
      size="small"
      id="PRO-bfa7182c-87b2-4609-8b2d-914503e30bc0"
    >
      <a-select-option value="en-GB">English</a-select-option>
      <a-select-option value="zh-CN">中文</a-select-option>
    </a-select>
    <div class="mr10">
      <span>{{ $t('welcome') }}！</span>
      <a-avatar
        size="small"
        class=" cp"
        v-if="store.state.user.userInfo.avatar"
        :src="store.state.user.userInfo.avatar"
      >
        <template #icon>
          <UserOutlined />
        </template>
      </a-avatar>
      <a-avatar v-else size="small" class="cp">
        <template #icon>
          <UserOutlined />
        </template>
      </a-avatar>
      <span style="margin-right:10px; margin-left:4px;">{{
        store.state.user.userInfo.userName
      }}</span>
      <span v-if="store?.state?.assessSimulate?.hasSimulate || state.isVirtual">
        <a
          href="javascript:;"
          class="mr-10px text-[#1890ff]"
          v-if="state.isVirtual"
          @click="simulationLogout"
          >退出模拟</a
        >
        <a-popconfirm
          v-else
          v-model:open="state.showSimulate"
          ok-text="确认"
          cancel-text="关闭"
          @visibleChange="handleVisibleChange"
          @cancel="showSimulate = false"
          trigger="click"
          :okButtonProps="{
            disabled: state.isPending
          }"
          :cancelButtonProps="{
            disabled: state.isPending
          }"
          @confirm="handleSimulate"
        >
          <a href="javascript:;" class="mr-10px text-[#1890ff]"> 模拟</a>
          <template #title>
            <div class="mb-5px">模拟用户</div>
            <cps-select
              class="w-200px"
              v-model:value="state.simulateUser"
              :url="`${state.portalUrl}/portal/user/list`"
              :params="{
                page: 1,
                pageSize: 100
              }"
              searchField="name"
              method="get"
              label="name"
              labelValue="id"
              respField="data.list"
              immediate
              showSearch
            ></cps-select>
            <div class="mt-10px" v-if="state.isPending">
              <a-spin :indicator="state.indicator" />等待用户确认中...
            </div>
          </template>
        </a-popconfirm>
      </span>

      <a
        v-if="state.showLoginout"
        id="PRO-85a892a9-f7cf-4826-8bf9-a3bad23e7e48"
        @click="doLogout"
        class="tac"
        >{{ $t('logout') }}</a
      >
    </div>
  </div>

  <div class="global-search" v-if="state.showSearch">
    <div class="global-search-mask"></div>
    <div class="global-search-panel">
      <div id="globalSearchPanel" class="global-search-wrapper">
        <SearchOutlined class="search-icon mr10" />
        <a-select
          showSearch
          allowClear
          ref="searchRef"
          :placeholder="
            state.lang === 'zh-CN' ? '搜索系统，功能' : 'Search menus...'
          "
          popupClassName="global-search-select"
          v-model:value="state.searchValue"
          :dropdownStyle="{ backgroundColor: '#f5f5f5' }"
          :filter-option="false"
          :not-found-content="state.fetching ? undefined : null"
          :open="state.showSearchOptionsPanel"
          :defaultActiveFirstOption="false"
          :getPopupContainer="getPopupContainer"
          @search="handleSearch"
          @change="handleSearchChange"
          @dropdownVisibleChange="handleSearchOptionsOpen"
        >
          <a-select-opt-group
            v-if="
              !!state.historySearchList.length && !state.searchOptions.length
            "
          >
            <template #label>
              <span>
                {{ state.lang === 'zh-CN' ? '历史记录' : 'History Search' }}
              </span>
            </template>
            <a-select-option
              v-for="item of state.historySearchList"
              :value="item.path"
              :key="item.label"
              >{{ item.label }}</a-select-option
            >
          </a-select-opt-group>
          <a-select-option
            v-else
            v-for="item of state.searchOptions"
            :value="item.path"
            :key="item.label"
          >
            {{ item.label }}
          </a-select-option>
          <template v-if="state.fetching" #notFoundContent>
            <a-spin size="small" />
          </template>
        </a-select>
      </div>
    </div>
  </div>
  <noticeInfoList v-if="state.showNoticeInfoList" />
</template>

<script setup>
// import { cupshe_GA } from 'cupshe-ga'
import {
  onMounted,
  reactive,
  onBeforeUnmount,
  inject,
  provide,
  h,
  nextTick,
  ref
} from 'vue'
import { useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import {
  UserOutlined,
  SearchOutlined,
  FullscreenOutlined,
  FullscreenExitOutlined,
  LoadingOutlined
} from '@ant-design/icons-vue'
import { useStore } from 'vuex'
import { setI18n } from 'cupshe-i18n'
import { pinyin } from 'pinyin-pro'

import { login_sign_out_get } from 'server/modules/351.js'
import { _browserLanguage, postMessageToSub } from 'cupshe-utils'
import { removeCookie } from 'utils/index.js'
import { PORTAL_SEARCH_HISTORY_LIST } from 'utils/utils.js'
import download from './Download'
import noticeInfoList from '../../views/NoticePublishCenter/components/noticeInfoList.vue'
import { useNavbar } from './share.js'

const props = defineProps({
  collapsed: {
    type: Boolean
  }
})

const langArrays = ['en-GB', 'zh-CN']
const store = useStore()
const router = useRouter()
const openFrame = inject('openFrame')
const parentState = inject('parentState')
const state = reactive({
  portalUrl: process.env.VUE_APP_PORTAL,
  indicator: h(LoadingOutlined, {
    style: {
      fontSize: '20px',
      marginRight: '10px'
    },
    spin: true
  }),
  showSimulate: false,
  isPending: false,
  simulateUser: null,
  isVirtual: JSON.parse(localStorage.getItem('isVirtual')) || false,
  showNoticeInfoList: false,
  showLoginout: true,
  showSearch: false,
  showSearchOptionsPanel: false,
  username: 'Cupshe',
  isOpen: props.collapsed,
  fetching: false,
  searchValue: undefined,
  searchOptions: [],
  lang: 'en-GB',
  historySearchList:
    JSON.parse(localStorage.getItem(PORTAL_SEARCH_HISTORY_LIST)) || []
})
const searchRef = ref()
const { handleSimulate, simulationLogout } = useNavbar(state)
const pinyinCache = new Map()

provide('navBarState', state)

const gaApi = ({ btn_id, btn_name }) => {
  const { userName, userId } = store.state.user.userInfo
  // cupshe_GA(
  //   'click',
  //   {
  //     shop_id: '101',
  //     log_type: '2',
  //     event_category: 'click',
  //     event_name: 'btn_click',
  //     referer: window.history.state.back
  //   },
  //   {
  //     btn_id,
  //     btn_name,
  //     menu_name: null,
  //     menu_id: null,
  //     system_code: 'PRO',
  //     system_name: 'Portal统一登录系统',
  //     uname: userName,
  //     uid: userId,
  //     time: new Date()
  //   }
  // )
}

const doLogout = async () => {
  gaApi({
    btn_name: '登出',
    btn_id: 'PRO-85a892a9-f7cf-4826-8bf9-a3bad23e7e48'
  })
  const result = await login_sign_out_get().catch(() => {
    message.info('退出失败')
  })
  if (result.success) {
    removeCookie('token')
    store.commit(
      'app/SET_RESETSTATE',
      {},
      {
        root: true
      }
    )
    store.commit(
      'user/SET_RESETSTATE',
      {},
      {
        root: true
      }
    )
    window.localStorage.clear()
    sessionStorage.clear()
    message.info('您已经退出登录！')
    if (process.env.NODE_ENV === 'development') {
      router.push('/Login')
    } else {
      location.href = `https://${location.host}/login`
    }
  }
}

const handleVisibleChange = visible => {
  // 阻止自动关闭逻辑
  if (!visible) {
    state.showSimulate = true
  }
}

const getPopupContainer = triggerNode => {
  return triggerNode.parentElement
}

const setHistorySearchList = data => {
  const idx = state.historySearchList.findIndex(
    item => item.label === data.label
  )
  if (idx === -1) {
    state.historySearchList.unshift(data)
  } else {
    const option = { ...state.historySearchList[idx] }
    state.historySearchList.splice(idx, 1)
    state.historySearchList = [option, ...state.historySearchList]
  }
  if (state.historySearchList.length > 10) {
    state.historySearchList = state.historySearchList.slice(0, 9)
  }
  localStorage.setItem(
    PORTAL_SEARCH_HISTORY_LIST,
    JSON.stringify(state.historySearchList)
  )
}

const openSearchPanel = () => {
  state.showSearch = true
  state.searchValue = undefined
  state.searchOptions = []

  // 自动获取焦点
  nextTick(() => {
    const input = searchRef.value?.$el?.querySelector('input')
    if (input) input.focus()
    state.showSearchOptionsPanel = true
  })
}

const closeSearchPanel = () => {
  state.showSearch = false
  state.searchValue = undefined
  state.searchOptions = []
}

const onChange = () => {
  langChange()
  location.reload()
  state.gaApi({
    btn_name: '切换中英文',
    btn_id: 'PRO-bfa7182c-87b2-4609-8b2d-914503e30bc0'
  })
}
// 语言切换
const langChange = () => {
  setI18n(state.lang)
  // reload()
  const iframe = window.currentIframe
  postMessageToSub(iframe, {
    type: 'language',
    value: {
      lang: localStorage.getItem('lang'),
      systemId: store.state.app.otherSystemId,
      env: process.env.VUE_APP_MODE
    }
  })
}

const handleSearchOptionsOpen = val => {
  state.showSearchOptionsPanel = val
}

const handleSearchChange = (_, b) => {
  if (!b.key || !b.value) {
    return
  }
  const item = {
    menuName: b.key
      .split('-')
      .slice(1)
      .join('-'),
    menuPath: b.value
  }
  openFrame(item)
  setHistorySearchList({
    label: b.key,
    path: b.value
  })
  closeSearchPanel()
}

const getTextWithPinyin = key => {
  if (pinyinCache.has(key)) {
    return pinyinCache.get(key)
  }
  const toneList = pinyin(key, {
    toneType: 'none',
    type: 'array'
  })
  const patternList = pinyin(key, {
    pattern: 'initial',
    type: 'array'
  })
  // eslint-disable-next-line prettier/prettier
  const purePatternList = patternList.find(item => /zh|ch|sh/.test(item)) ? patternList.map(item => item.replace(/zh/g, 'z').replace(/ch/g, 'c').replace(/sh/g, 's')) : []
  const result = toneList
    .concat(patternList)
    .concat(purePatternList)
    .map(item => item.toLocaleLowerCase())
    .join('')
  pinyinCache.set(key, result)
  return result
}

const handleSearch = value => {
  state.searchOptions = []
  if (!value.trim()) {
    return false
  }
  state.fetching = true
  const getChildrenMenu = (list, name) => {
    list.forEach(item => {
      const isMatched =
        state.lang === 'zh-CN'
          ? item.menuName.toLowerCase().includes(value.toLowerCase()) ||
            getTextWithPinyin(item.menuName, value.toLowerCase()).includes(
              value.toLowerCase()
            )
          : item.menuNameEn.toLowerCase().includes(value.toLowerCase())
      if (item.menuType === 2 && isMatched) {
        state.searchOptions.push({
          label:
            state.lang === 'zh-CN'
              ? name + '-' + item.menuName
              : name + '-' + (item.menuNameEn || item.menuName),
          systemName: name,
          path: item.menuPath,
          value: item.id
        })
      } else if (item.childrenList && item.childrenList.length) {
        getChildrenMenu(item.childrenList, name)
      }
    })
  }
  const menus = store.state.user.menus
  let count = 0
  menus.forEach(item => {
    count++
    let systemName = ''

    if (item.parentId === 0 && item.menuType === 0) {
      systemName = state.lang === 'zh-CN' ? item.menuName : item.menuNameEn
    }
    if (item.childrenList && item.childrenList.length) {
      getChildrenMenu(item.childrenList, systemName)
    }

    if (menus.length === count) {
      setTimeout(() => {
        state.fetching = false
      }, 300)
    }
  })
}

const checkFeishuClient = () => {
  try {
    if (window.h5sdk && window.h5sdk.ready) {
      state.showLoginout = false
    } else {
      state.showLoginout = true
    }
  } catch (error) {
    console.log(error)
  }
}

const handleKeydown = e => {
  if (
    e.shiftKey &&
    e.key.toLowerCase() === 'f' &&
    !['INPUT', 'TEXTAREA'].includes(document.activeElement.tagName)
  ) {
    nextTick(() => {
      openSearchPanel()
      e.preventDefault()
      e.stopPropagation()
    })
  } else if (e.key === 'Escape') {
    nextTick(() => {
      closeSearchPanel()
    })
  }
}

const handleHideSearchPanel = e => {
  if (
    e.target.closest('#globalSearchPanel') ||
    e.target.closest('.anticon-search')
  ) {
    return
  }
  closeSearchPanel()
}

onBeforeUnmount(() => {
  window.document.removeEventListener('click', handleHideSearchPanel)
  window.removeEventListener('keydown', handleKeydown)
})

onMounted(() => {
  const lang = localStorage.getItem('lang')
  if (!lang || !langArrays.includes(lang)) {
    state.lang = _browserLanguage(true) ? 'zh-CN' : 'en-GB'
  } else {
    state.lang = lang
  }

  window.removeEventListener('keydown', handleKeydown)
  window.addEventListener('keydown', handleKeydown)
  window.document.removeEventListener('click', handleHideSearchPanel)
  window.document.addEventListener('click', handleHideSearchPanel)

  langChange()
  checkFeishuClient()
  store.commit('GET_NOTICE_COUNT')
  store.commit('GET_HAS_SIMULATE')
})
</script>

<style lang="scss" scoped>
.left-options {
  flex: 1;
  margin-right: 20px;
  min-width: 0;
  overflow: hidden;
  .menu-fold {
    padding: 0 24px;
    cursor: pointer;
  }
}

.right-options {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  white-space: nowrap;
}
.pointer {
  cursor: pointer;
}
.lang {
  :deep .portal-ant-select-selector {
    border: unset !important;
    box-shadow: unset !important;
  }
  :deep
    .portal-ant-select-focused:not(.portal-ant-select-disabled).portal-ant-select:not(.portal-ant-select-customize-input)
    .portal-ant-select-selector {
    box-shadow: unset !important;
  }
}
</style>
<style lang="scss">
body {
  .portal-ant-avatar-sm {
    width: 20px;
    height: 20px;
    line-height: 20px;
  }
  .global-search-select {
    top: 46px !important;
    background-color: rgb(239, 239, 239) !important;
    transform: translateY(28px);
    border-radius: 0 0 8px 8px;
    box-shadow: 5px 8px 8px 2px rgba(0, 0, 0, 0.1);
    .portal-ant-select-dropdown-content {
      min-height: 48px;
      padding: 0 6px;

      .portal-ant-select-item-option {
        min-height: 36px;
        line-height: 26px;
        &:hover,
        &.portal-ant-select-item-option-active {
          background-color: #fefefe;
          border-radius: 4px;
        }
      }

      .portal-ant-spin {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateX(-12px);
      }
    }
  }
}
.global-search {
  display: block;
}
.global-search-mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
}
.global-search-panel {
  display: flex;
  position: fixed;
  top: 100px;
  left: 50%;
  align-items: center;
  z-index: 1000;
  transform: translateX(-50%);
  .global-search-wrapper {
    position: relative;
  }
  .search-icon {
    position: absolute;
    top: calc(50% - 12px);
    left: 20px;
    font-size: 24px;
    z-index: 2;
  }
  .portal-ant-select {
    flex: 1;
    width: 560px;
    height: 80px;
    display: flex;
    align-items: center;
    background-color: rgb(239, 239, 239);
    box-shadow: 5px 8px 8px 2px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }
  .portal-ant-select-selector {
    display: unset;
    height: 100%;
    line-height: normal;
    transform: translateY(2px);
    transition: none !important;
  }
  .portal-ant-select-selection-search {
    left: 58px !important;
    top: -6px !important;
    padding: 0 8px;
    height: 42px;
    line-height: 42px;
    background: rgb(225, 225, 225);
    border-radius: 6px;
  }
  .portal-ant-select-arrow {
    display: none;
  }
  .portal-ant-select-clear {
    right: 36px !important;
    background-color: rgb(225, 225, 225) !important;
  }
  .portal-ant-select:not(.portal-ant-select-customize-input)
    .portal-ant-select-selector {
    background: none;
    border: unset;
  }
  .portal-ant-select-focused:not(.portal-ant-select-disabled).portal-ant-select:not(.portal-ant-select-customize-input)
    .portal-ant-select-selector {
    border-color: unset;
    box-shadow: unset;
  }

  .portal-ant-select-selection-placeholder {
    position: relative;
    padding-left: 60px !important;
    z-index: 2;
  }
}
.portal-ant-popover-message > .anticon {
  display: none !important;
}
.portal-ant-popover-message-title {
  padding-left: 0 !important;
  color: #565656d9;
}
</style>
